import { render, staticRenderFns } from "./atenatal_details.vue?vue&type=template&id=4317332e&scoped=true&"
import script from "./atenatal_details.vue?vue&type=script&lang=js&"
export * from "./atenatal_details.vue?vue&type=script&lang=js&"
import style0 from "./atenatal_details.vue?vue&type=style&index=0&id=4317332e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4317332e",
  null
  
)

export default component.exports